import React from "react";
import { Calendar, Clock } from "lucide-react";

const fmtDate = (v) => {
  if (!v) return "";
  const [y, m, d] = v.split("-");
  return `${d}.${m}.${y}`;
};

const wrap =
  "relative w-full box-border overflow-hidden bg-white border border-[#E9E5DE] rounded-2xl py-3.5 pl-10 pr-3 transition-all duration-200 focus-within:border-[#2B4BFF] focus-within:ring-2 focus-within:ring-[#2B4BFF]/15";
const display = "block text-center font-body text-sm text-[#0B1533] leading-5 select-none";
// Native input sits transparently on top; absolute inset-0 forces it to the
// parent width, overriding the intrinsic min-width iOS Safari otherwise enforces
// (which used to cause horizontal overflow on mobile).
const nativeCls = "absolute inset-0 w-full h-full min-w-0 max-w-full box-border opacity-0 cursor-pointer";

export const DateField = ({ value, min, onChange, testid = "date-field" }) => (
  <div className={wrap} data-testid={testid}>
    <Calendar size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#9CA0B0] pointer-events-none z-10" />
    <span className={display}>{fmtDate(value)}</span>
    <input type="date" min={min} value={value} onChange={(e) => onChange(e.target.value)} className={nativeCls} />
  </div>
);

export const TimeField = ({ value, onChange, testid = "time-field" }) => (
  <div className={wrap} data-testid={testid}>
    <Clock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#9CA0B0] pointer-events-none z-10" />
    <span className={value ? display : display + " text-[#9CA0B0]"}>{value || "Zeit wählen"}</span>
    <input type="time" step={300} value={value} onChange={(e) => onChange(e.target.value)} className={nativeCls} />
  </div>
);
